import { ActionType, getType } from 'typesafe-actions'

import N from '../../utils/assert-never'
import * as actions from './actions'
import { initial as initialState, Type as State } from './state'

export type Action = ActionType<typeof actions>

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  switch (action.type) {
    case getType(actions.getProject):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }
    case getType(actions.getProjectComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          return {
            ...state,
            project: action.payload.payload,
            loading: false,
          }
        } else {
          return state
        }
      } else {
        return state
      }

    case getType(actions.doCreativeAction):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }
    case getType(actions.doCreativeActionComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          const newCreative = action.payload.payload.creative

          return {
            ...state,
            loading: false,
            project:
              state.project != null
                ? {
                    ...state.project,
                    formatsets: state.project.formatsets.map((formatset) => {
                      return {
                        ...formatset,
                        creatives: formatset.creatives.map((creative) => {
                          if (creative.id === newCreative.id) {
                            return newCreative
                          } else {
                            return creative
                          }
                        }),
                      }
                    }),
                  }
                : state.project,
          }
        } else {
          return {
            ...state,
            loading: false,
            error: action.payload.payload.message,
          }
        }
      } else {
        return state
      }
    case getType(actions.doProjectAction):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }
    case getType(actions.doProjectActionComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          return {
            ...state,
            loading: false,
          }
        } else {
          return {
            ...state,
            loading: false,
            error: action.payload.payload.message,
          }
        }
      } else {
        return state
      }

    case getType(actions.saveProject):
      if ('payload' in action) {
        return { ...state, saving: true }
      } else {
        return state
      }

    case getType(actions.addedFormatsets):
      if (state.project == null) {
        return state
      }

      return {
        ...state,
        project: {
          ...state.project,
          formatsets: [...state.project.formatsets, ...action.payload],
        },
      }

    case getType(actions.setProjectComment):
      if ('payload' in action) {
        return { ...state }
      } else {
        return state
      }

    case getType(actions.removeFormatSet):
      if ('payload' in action) {
        return { ...state }
      } else {
        return state
      }

    case getType(actions.saveProjectCompleted):
      if ('payload' in action && state.project !== null) {
        return {
          ...state,
          saving: false,
        }
      } else {
        return state
      }

    case getType(actions.getPlatforms):
      if ('payload' in action) {
        return {
          ...state,
          loading: true,
        }
      } else {
        return state
      }

    case getType(actions.getPlatformsComplete):
      if ('payload' in action) {
        if (action.payload.type === 'success') {
          return {
            ...state,
            loading: false,
            platforms: action.payload.payload,
          }
        } else {
          return state
        }
      } else {
        return state
      }

    case getType(actions.leaveProjectPage):
      return initialState
  }

  return N(action, state)
}
